import {gavelSvg as Icon__small__gavelSvg} from '../Icon__small/Icon__small--gavel.js';

export var gavel = {
  name: 'gavel',
  category: 'icon',
  colorable: true,
  svg: Icon__small__gavelSvg,
};
